// Règle unique pour les actions de changement de statut d'une conversation
// (liste /admin/inbox). Utilisée à la fois pour décider quels boutons afficher
// (InboxTable) et pour empêcher l'exécution d'une action non autorisée
// (useInbox), même en cas d'appel direct hors UI.
//
// - OPEN     : seule la clôture est possible.
// - CLOSED   : seul l'archivage est possible.
// - ARCHIVED : état terminal, aucune action de statut.
export const CONVERSATION_STATUS = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
  ARCHIVED: "ARCHIVED",
};

export const canCloseConversation = (status) => status === CONVERSATION_STATUS.OPEN;

export const canArchiveConversation = (status) => status === CONVERSATION_STATUS.CLOSED;
